import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Output } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../../../../environments/environment';

@Injectable()
export class UserUpdateStatusService {
    private urlPrefix: string = environment.appUrl;
    constructor(
        private http: Http,
        private httpClient: HttpClient
    ) {}

    update(id): Observable<any> {
        const url = this.urlPrefix + 'users/' + id + '/update-status';
        return this.httpClient
            .put(url, {
            }, {
                observe: 'response'
            })
            .map(
                res => {
                    if (res.status === 200) {
                        return res.body;
                    } else {
                        return Observable.throw(null);
                    }
                }
            )
            .catch(
                err => {
                    return Observable.throw(err);
                }
            );
    }

    suspend(id): Observable<any> {
        const url = this.urlPrefix + 'users/' + id + '/suspend';
        return this.httpClient
            .put(url, {
            }, {
                observe: 'response'
            })
            .map(
                res => {
                    if (res.status === 200) {
                        return res.body;
                    } else {
                        return Observable.throw(null);
                    }
                }
            )
            .catch(
                err => {
                    return Observable.throw(err);
                }
            );
    }
    

    unsuspend(id): Observable<any> {
        const url = this.urlPrefix + 'users/' + id + '/unsuspend';
        return this.httpClient
            .put(url, {
            }, {
                observe: 'response'
            })
            .map(
                res => {
                    if (res.status === 200) {
                        return res.body;
                    } else {
                        return Observable.throw(null);
                    }
                }
            )
            .catch(
                err => {
                    return Observable.throw(err);
                }
            );
    }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/user/user-detail/user-update-status.service.ts